import React, { useState, useEffect } from 'react'
import { Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import axios from 'axios'
import Select from 'react-select'
import { useStyles } from '../styles'

// components
import Dialog from '../../../../../components/Dialog'



export default function JobFunctionFormDlg(props) {

	const classes = useStyles()
	const [err, setErr] = useState('')
	const [selectedTitle , setSelectedTitle] = useState(null)
	const [titleSelectableValues , setTitleSelectableValues] = useState([])

	useEffect(() => {
		axios('/api/unique_job_titles')
			.then((res) => {
				const jobTitles = res.data.data.map(d => {
					return { value: d.job_title_only, label: d.job_title_only }
				})
				setTitleSelectableValues(jobTitles)
			})
			.catch((error) => {
				console.log(error)
			})
	}, [])

	const saveFunction = async () => {
		setErr('')

		if(selectedTitle === null) {
			setErr('Select a Title')
			return
		}

		const payload = {
			name: selectedTitle.value,
			type : 'job_title',
		}

		try {
			const res = await axios.post(`/api/company_data`, payload)
			const newTitle = res.data.data
            props.onSuccess({value: newTitle.id, label: newTitle.name})
        } catch(e) {
            setErr('Sorry, we are unable to add title')
        }
	}

	return (
		<Dialog
			size={'sm'}
			title={'Add New Job Title To Your Company'}
			isOpen={props.isOpen}
			onClose={() => props.onClose()}
			actions={[
				{
					title: 'Cancel',
					func: () => {
						props.onClose()
					},
				},
				{
					title: 'Add',
					func: async () => {
						await saveFunction()
					},
				},
			]}
		>
			<div className={classes.selectionArea}>
				{
					err ?
						<Typography>{err}</Typography>
						:
						null
				}
				<Select
					value={selectedTitle}
					onChange={(newSelectedTitle) => setSelectedTitle(newSelectedTitle)}
					options={titleSelectableValues}
				/>
			</div>
		</Dialog>
	)
}

JobFunctionFormDlg.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSuccess: PropTypes.func.isRequired,
}
